module.exports = "../../app/cells/components/dev_loading_cell.rb";